// components/GeneralInfo.jsx
import React from "react";

const GeneralInfo = ({
  nombre,
  setNombre,
  numero,
  editableNumero,
  setNumero,
  clientesList,
  cliente,
  setCliente,
  fechaEmision,
  setFechaEmision,
  fechaVencimiento,
  setFechaVencimiento,
  descripcion,
  setDescripcion,
  moneda,
  handleMonedaChange,
  impuesto,
  setImpuesto,
  editMode,
  openConfigModal,
}) => {
  return (
    <section
      className="info-general"
      style={!editMode ? { pointerEvents: "none", opacity: 0.9 } : {}}
    >
      <div className="info-header">
        <h1 className="calculador-title">Información General</h1>
        <i className="bi bi-chevron-down" style={{ marginLeft: "10px" }}></i>
      </div>
      <div className="info-content">
        {/* Fila 1: Nombre/Referencia y Número */}
        <div className="calculador-form-row fila-2fr-1fr">
          <div className="calculador-form-group referencia-group">
            <label className="labels-inputs">Nombre o Referencia*</label>
            <input
              type="text"
              className="nombre-input"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
            />
          </div>
          <div className="calculador-form-group numero-group">
            <label className="labels-inputs">Número</label>
            <div className="numero-box">
              {editableNumero ? (
                <input
                  type="text"
                  value={numero}
                  onChange={(e) => setNumero(e.target.value)}
                  style={{ border: "none", outline: "none" }}
                />
              ) : (
                <strong>{numero}</strong>
              )}
              <i
                className="bi bi-gear-fill"
                style={{
                  cursor: editMode ? "pointer" : "default",
                  opacity: editMode ? 1 : 0.5,
                }}
                onClick={openConfigModal}
              ></i>
            </div>
          </div>
        </div>
        {/* Fila 2: Cliente y Fechas */}
        <div className="calculador-form-row fila-dos-columnas">
          <div className="calculador-form-group">
            <label className="labels-inputs">Razón Social</label>
            <div className="calculador-input-container" style={{ position: "relative" }}>
              <i className="bi bi-person-fill"></i>
              <select
                className="cliente-input"
                value={cliente}
                onChange={(e) => setCliente(e.target.value)}
              >
                <option value="">Seleccionar cliente</option>
                {clientesList
                  .slice()
                  .sort((a, b) => a.empresa.localeCompare(b.empresa))
                  .map((cli) => (
                    <option key={cli.id} value={cli.empresa}>
                      {cli.empresa}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          <div className="calculador-form-group">
            <label className="labels-inputs">Fechas</label>
            <div className="date-inputs">
              <input
                type="date"
                className="date-btn"
                value={fechaEmision}
                onChange={(e) => setFechaEmision(e.target.value)}
              />
              <input
                type="date"
                className="date-btn"
                value={fechaVencimiento}
                onChange={(e) => setFechaVencimiento(e.target.value)}
              />
            </div>
          </div>
        </div>
        {/* Fila 3: Descripción */}
        <div className="calculador-form-group fila-una-columna">
          <label className="labels-inputs">Descripción / Notas</label>
          <textarea
            className="descripcion-textarea"
            rows="2"
            value={descripcion}
            onChange={(e) => setDescripcion(e.target.value)}
          ></textarea>
        </div>
        {/* Fila 4: Moneda e Impuesto */}
        <div className="calculador-form-row fila-tres-columnas">
          <div className="calculador-form-group">
            <label className="labels-inputs">Moneda</label>
            <div className="moneda-container">
              <img
                src={
                  moneda === "USD"
                    ? "https://flagcdn.com/w40/us.png"
                    : "https://flagcdn.com/w40/mx.png"
                }
                alt="Bandera"
                className="moneda-flag"
              />
              <select className="moneda-select" value={moneda} onChange={handleMonedaChange}>
                <option value="USD">Dólar USD</option>
                <option value="MXN">Pesos MXN</option>
              </select>
            </div>
          </div>
          <div className="calculador-form-group">
            <label className="labels-inputs">Impuesto</label>
            <select
              className="form-select"
              value={impuesto}
              onChange={(e) => setImpuesto(e.target.value)}
            >
              <option>IVA 16%</option>
              <option>IVA 8%</option>
            </select>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GeneralInfo;
